import { http } from "api/http";

type AddAttachment = {
  taskId: number;
  data: FormData;
  collectId: number;
  origin: string;
};

const getActivity = ({ queryKey }) => {
  return http.get("/activity", { params: { ...queryKey[1] } });
};

const getStates = () => {
  return http.get("/common/states");
};

const invoiceUpload = (invoiceData: any) => {
  return http.post("/common/invoiceUpload", invoiceData);
};

const receiptUpload = (invoiceData: any) => {
  return http.post("/common/receiptUpload", invoiceData);
};

const collectDataAdd = (data: any) => {
  return http.post("/collect-data", data);
};

const updateCollectData = ({ id, data }: any) => {
  return http.put(`/collect-data/${id}`, data);
};

const getTaskCollectData = ({ queryKey }: any) => {
  return http.get(`/collect-data/task/${queryKey[1]}`);
};

const getCollectData = ({ queryKey }: any) => {
  return http.get(`/collect-data/${queryKey[1]}`);
};

const getCollectAttachments = ({ queryKey }: any) => {
  return http.get(`/collect-data/attachments/${queryKey[1]}`);
};

const addCollectAttachment = ({ origin, taskId, data, collectId }: AddAttachment) => {
  return http.post(`/collect-data/${taskId}/${collectId}/${origin}/attachments`, data);
};

const invoiceReminder = (invoiceData: any) => {
  return http.post("/common/invoiceReminder", invoiceData);
};

export {
  getActivity,
  getStates,
  invoiceUpload,
  receiptUpload,
  collectDataAdd,
  getCollectData,
  addCollectAttachment,
  getCollectAttachments,
  getTaskCollectData,
  updateCollectData,
  invoiceReminder,
};
